import React, { useEffect } from 'react';
import '../../scss/Invoice/InvoicesPagination.scss';

const InvoicePagination = ({ handlePageClick, limit, searchResult, nextPage, prevPage, input, pageCount, setpageCount, initialPage, finalPage }) => {

    useEffect(() => {
        setpageCount(Math.ceil(searchResult.totalRecords / limit));
    }, [searchResult, limit]);

    const pageNumbers: number[] = [];

    for (let i = 1; i <= pageCount; i++) {
        pageNumbers.push(i);
    };
    const currentPath = window.location.pathname;

    return (
        <nav className='pagination justify-content-center' aria-label='...'>
            <ul className='pagination justify-content-center mb-0'>
                <li className={input.currentPage === 1 ? 'page-item disabled' : 'page-item'}>
                    <a className='page-link' href={`${currentPath}#`} aria-label="Initial" onClick={(e) => {
                        e.preventDefault();
                        initialPage();
                    }}>
                        <span aria-hidden="true">&laquo;</span>
                    </a>
                </li>
                <li className={input.currentPage === 1 ? 'page-item disabled' : 'page-item'}>
                    <a className='page-link' href={`${currentPath}#`} aria-label="Previous" onClick={(e) => {
                        e.preventDefault();
                        prevPage();
                    }}>
                        <span aria-hidden="true">&lt;</span>
                    </a>
                </li>
                {pageNumbers.map(num => (
                    <li className={input.currentPage === num ? 'page-item active' : 'page-item'} key={num}>
                        <a className='page-link' href={`${currentPath}#`} onClick={(e) => {
                            e.preventDefault();
                            handlePageClick(num);
                        }}>{num}</a>
                    </li> 
                ))}
                <li className={input.currentPage === pageCount ? 'page-item disabled' : 'page-item'}>
                    <a className='page-link' href={`${currentPath}#`} aria-label="Next" onClick={(e) => {
                        e.preventDefault();
                        nextPage();
                    }}>
                        <span aria-hidden="true">&gt;</span>
                    </a>
                </li>
                <li className={input.currentPage === pageCount ? 'page-item disabled' : 'page-item'}>
                    <a className='page-link' href={`${currentPath}#`} aria-label="Final" onClick={(e) => {
                        e.preventDefault();
                        finalPage();
                    }}>
                        <span aria-hidden="true">&raquo;</span>
                    </a>
                </li>
            </ul>
        </nav>
    )
}

export default InvoicePagination;